export default {
    site: {
        common: {
            hello: "Olá",
                thankYou: "Obrigado",
                forMoreInfo: "para mais informações",
                hoverOverColumnHeaders: "Passe o mouse sobre os cabeçalhos da coluna para obter mais informações.",
                username: "Usuário",
                score: "Pontuação",
                points: "Pontos",
                pointsAbbreviation: "pts",
                chapter: "Capítulo",
                tier: "Tier",
                t1: "T1",
                t2: "T2",
                t3: "T3",
                collectionsPerDay: "Coletas por dia",
                relicBoostPercent: "Impulso de relíquia %",
                mountainHallPercentShort: "Pref.Mont.%", // used in table heading keep it short.
                updated: "Atualizado",
                lastUpdated: "Última atualização",
                created: "Criado",
                role: "Cargo",
                Fellow: "Companheiro",
                Ambassador: "Embaixador",
                Mage: "Mago" ,
                Archmage: "Arquimago" ,
                saveChanges: "Salvar alterações",
                copy: "Copiar",
                close: "Fechar",
                cancel: "Cancelar",
                action: "Fazer",
                date: "Data",
                Left: "Esquerda",
                Joined: "Ingressou",
                human: "Humano",
                elf: "Elfo",
                search: "Pesquisar",
                enter: "Entrar",
                yes: "Sim",
                no: "Não",
                tournament: "Torneio",
                tournaments: "Torneios",
                fellowship: "Irmandade",
                player: "Jogador",
                member: "Membro",
                history: "Histórico",
                tournamentHistory:  "Histórico Torneio",
                scoreHistory: "Histórico de pontos",
                server: "Servidor",
                lastWeekGain: "Ganho da Última Semana",
                comingSoon: "Em breve",
                chest: "Cofre",
                yourServer: "Seu servidor",
                allServers: "Todos os servidores",
                boosts: "Impulso",
                marble: "Mármore",
                steel: "Aço",
                planks: "Tábuas",
                crystal: "Cristal",
                scrolls: "Pergaminho",
                silk: "Seda",
                elixir: "Elixir",
                magic_dust: "Pó Mágico",
                gems: "Gemas",
                sentient: "Sensoriais",
                goods: "Produtos",
                average: "Média",
                expansions: "Expansões", // 5x5 grids
                cultureBoostMinimum: "Mínimo impulso de cultura",
                cultureBoostCalculated: "Impulso de Cultura Calculado",
                neighborlyHelp: "Ajuda dos vizinhos",
                neighborlyHelpAbbreviation: "AV"
        },

        // HIGH PRIORITY
        nav: {
            home: "Inicio",
                players: "Jogadores",
                fellowships: "Irmandades",
                tournaments: "Torneios",
                contact: "Contato",
                donate: "Doaçoes",
                faq: "FAQ",
                news: "Novo",
                privacyPolicy: "Política de Privacidade",
                me: "Eu",
                myFellowship: "Minha Irmandade",

                // NOTE USED AT THE MOMENT
                globalStats: "Estatísticas Globais",
                articles: "Artigos",
                fellowshipAdventure: "Aventuras da Irmandade",
                recruit: "Recrutar",
        },
        // VERY HIGH PRIORITY!
        elvenArchitect: {
            viewCityOnElvenArchitect: "Ver a cidade no ElvenArchitect"
                ,obtainingLink: "Obtendo Link"
                ,successMessage: "Sucesso! Clique no link abaixo para iniciar o Elven Architect"
                ,ageOfLink: "O link acima mostrará a cidade como estava: "
                ,clickToGetCurrentCity: "<-- Clique para obter a cidade atual",
        },
        // High Priority
        playerSelection: {
            headline: "Ver o site como",
                description: "Isso atualizará várias partes do site que são personalizadas para o usuário do site. Exemplos incluem: minha Irmandade, meu usuário, torneios e páginas de ranking.",
                youAreViewing: "Você está vendo o site como {username} e {serverName}",
                changeUser: "Alterar jogador",
                enterYourUsernameToGetStarted: "Digite seu nome de usuário Elvenar para começar",
                thisIsNotASignup:"Este não é um processo de inscrição. Ao inserir seu nome de usuário, simplesmente personalizamos o site adequadamente. Há muitos servidores Elvenar e exibiremos resultados de classificação para o seu servidor. Além disso, os links de sua irmandade e da página de usuário pessoal ficarão disponíveis."
        },
        searchBoxes: {
            enterFellowshipName: "Digite o nome da Irmandade",
                instructions: "Digite o nome e selecione uma.",
                noFellowship: "Irmandade não encontrada",
        },
        relativeTime: {
            // Relative time strings - note: these aren't yet implemented in the code
            daysAgo: "dias atrás",
                minsAgo: "minutos Atrás",
                hoursAgo: "horas Atrás",
                justNow: "Agora mesmo",
                never: "Nunca",
        },
        home: {
            welcome: "Bem-vindo ao Elven Stats!",
                youAreViewing: "Você está vendo o site como {username} e {serverName}",
                youCanChange: "Você pode alterar o usuário clicando no avatar no canto superior direito -ou- por <router-link to='/contact'>visitando esta página</router-link>",
                features: {
                headline: "Características",
                    fellowshipAdministration: {
                    headline: "Administração Irmandade <strong>MADO FÁCIL</strong>",
                        bullet1: "Acompanhamento automático de produtos impulsionados para ajudá-lo a equilibrar melhor sua Irmandade",
                        bullet2: "Acompanhamento / geração automática de e-mails de relatórios semanais, incluindo pontos, participação em torneios, crescimento semanal/mensal, reconhecimentos e melhores registros pessoais",
                        bullet3: "Ajudar a identificar desequilíbrios de produção de seus colegas, como suprimentos ou proporção incorreta dos produtos (tiers)",
                },
                elvenArchitectIntegration: {
                    headline: "ElvenArchitect <strong>Integração</strong>",
                        description: "Carregue sua cidade exatamente como está em ElvenArchitect em segundos! Use isso para planejar melhor a reorganização da sua próxima grande cidade ou para encontrar um espaço que você não sabia que tinha! Procure o logotipo do ElvenArchitect nas páginas dos jogadores."
                },
                advancedRankingLists: {
                    headline: "<strong>Listas de classificação avançadas</strong>",
                        bullet1: "Lista de classificação por áreas desbloqueadas (para comparar-se com as pessoas na mesma fase)",
                        bullet2: "Veja impulsos, número do capítulo e mais nas listas de jogadores.",
                },
                fellowshipTournamentTracking: {
                    headline: "Torneio Irmandade <strong>Rastreamento</strong>",
                        description: "Veja como sua Irmandade compete contra as outras. Desafie outras Irmandades a um duelo, uma competição amistosa e saudável!",
                },
                matchMaking: {
                    headline: "Corresponder <strong>Fazendo</strong>",
                        description: `ElvenStats rastreia os impulsos dos jogadores e as taxas de produção de mercadorias das Irmandades. Com essa informação, as Irmandades podem recrutar os candidatos certos para equilibrar seus produtos. Os usuários que procuram uma irmandade podem encontrar Irmandades que realmente precisam de seus impulsos. Economizando tempo e reduzindo a rejeição!`
                }
            }
        },
        fellowship: {
            stats: {
                rank: "classificação",
                    points: "Pontos",
                    medianUserScore: "<strong>Pontuação Média</strong>",
                    memberCount: "Membros <strong>contagem</strong>",
            },
            barCharts: {
                clickSlice: "Clique em uma fatia para detalhes (por membro)",
                    tier1: "Tier 1",
                    tier2: "Tier 2",
                    tier3: "Tier 3",
                    drillDown: "Voltar {0}"
            },
            idealCandidate: {
                heading: "Candidato Ideal",
                    description: "Ter uma pontuação em torno de {medianScore} e ter um ou mais dos seguintes impulsos: {boosts}",
                    note: "Algumas combinações de reforços não são possíveis. Veja {0}"
            },
            memberGoodsTable: {
                heading: "Boa Produção dos Membros",
                    description: `Esta tabela calcula quanto de cada produto sua irmandade faz. Nós tomamos como base/palpite sobre o que você e os 
                respectivos membros possuem de percentual de impulso 'está assumindo que cada membro faz 3 coleções por dia
                (2x9h e 1x3h). Para melhorar a precisão, pergunte aos membros da sua irmandade quais são seus valores reais e insira-os abaixo. Você pode
                salvar o que você digita para que ele apareça na próxima vez que você carregar essa página. Os gráficos de barras acima serão atualizados automaticamente depois que você fizer alterações.Passe o mouse sobre os cabeçalhos da coluna para obter mais informações sobre uma determinada coluna.`,
                    refreshButtonText: 'Atualizar lista de membros',
                    refreshButtonTip: 'Isso adicionará novos membros, removerá membros antigos, atualizará as funções da associação e atualizará as pontuações atuais.',
                    inactiveWarningTip: 'O usuário pode estar inativo, marcar a última atualização: {0}',
                    collectsPerDayValidation: "Deve estar entre 1-6",
                    boostPercentValidation: "Deve ser entre 40 - 700, não incluem bônus da Pref. das Montanhas",
                    perDayShort: "/dia",

                    // HIGH PRIORITY - IMPORTANT TOOLTIPS
                    scoreTip: "Os jogadores pontuam, por favor, note que isso não é atualizado em tempo real. É atualizado várias vezes por semana.",
                    chapterTip: "Este é o capítulo em que cada jogador está. Para referência: Elementais = 12, Halflings = 11, etc.",
                    boostTip: "Os jogadores aumentam a quantidade produzida por dia.",
                    collectsPerDayTip: `***EDITAVEL*** <br/>Coletas por dia. Esse é o número de vezes por dia que o usuário coleta mercadorias de seus produtos. Deve ser um valor entre 1 - 6.  1 = 1x24h, 2=2x9h, 3=2x9h + 1x3h, 4=1x9h + 3x3h, 5=4x3h + 1x9h, 6=5x3h + 1x9h<BR/>Por favor, veja o FAQ para mais informações.`,
                    relicBoostPercentTip: `***EDITAVEL***<br/>O Impulso da relíquia deverá estar entre 40-700. Não deverá ser incluido o percentual da Pref. das Montanhas dos jogadores. Isso é detectado automaticamente e adicionado no cálculo`,
                    mountainHallPercentTip: "Esta é a Porcentagem de aumento da Pref. das Montanhas que detectamos para esse usuário. É usado em conjunto com os % de aumento para calcular a porcentagem total de aumento.",
                    updatedTip: "Este é o momento em que a cidade dos jogadores foi analisada pela última vez. Este processo é o que define os impulsos, dados do Elven Architect , calcula a produção de todas as fábricas, % da Pref. das Montanhas e muito mais. Os dados do mapa da cidade são periodicamente buscados automaticamente, mas você pode forçar uma atualização abaixo clicando no botão Atualizar.",

            },
            coinsAndSuppliesTable: {
                heading: "Produção de Moedas / Suprimentos",
                    description: `A coluna chave aqui é "Suprimentos à esquerda", pois indica se um membro produzirá suprimentos suficientes para manter suas
                fábricas produzindo 24/7.  Use as chaves de alternância abaixo para levar em conta o aumento do mínimo de cultura dos jogadores (que é o impulso que você teria se não tivesse ajuda da vizinhança)
                e / ou o número de vezes que o membro coleta por dia (conforme especificado na Tabela de Mercadorias acima). DESLIGAR ambos é útil se você quiser ver quanto dos suprimentos são atribuídos
                para as fábricas e a cutura com apenas 100% de bonus. Finalmente, por favor, note que ter poucos itens negativos (~ 10% do total) restantes é bastante comum. Existem muitas maneiras dos jogadores
                aumentar seus suprimentos, como visitar os vizinhos, produzir suprimentos em intervalos mais rápidos (bebidas, ferramentas simples, pão ...) ou usando feitiços de poder de provisão.
                Pense no valor negativo como o que você precisaria compensar diariamente fazendo uma dessas opções.
                OBSERVAÇÃO: no momento em que a produção de tropas não é levada em conta nos suprimentos utilizados (somente produtos de Nível 1, Nível 2 e Nível 3), é possível que você precise de mais.`,

                    // These are the column text that show up under the icons. Keep them short.
                    minBoostPercent: "% Mín.Impulso",
                    made: "Feito",
                    used: "Usado",
                    left: "esquerda",

                    // Low Priority TOOL TIPS
                    minimumCultureBoostPercent: "A porcentagem de aumento de cultura. IMPORTANTE: isso é calculado supondo NÃO AJUDA DE VIZINHOS nas culturas. Na realidade, isso provavelmente será maior em suas cidades.",
                    moneyComputedTip: "A quantidade de moedas produzidas em um dia inclui quaisquer Maravilhas Antigas que produzem moedas.",
                    moneyUsedComputedTip: "A quantidade de moedas consumida pela produção de bens.",
                    moneyRemainingComputedTip: "Moedas - Moedas Usadas, é o excedente ou déficit em moedas que um jogador terá a cada dia",
                    suppliesComputedTip: "O número de suprimentos que seriam produzidos se todos as oficinas fossem definidas como 24x1 (caixas de ferramentas) + quaisquer maravilhas antigas. (não inclui bônus definidos)",
                    suppliesUsedComputedTip: "O número de suprimentos consumidos pela produção de bens. NÃO inclui suprimentos usados ​​pelo seu quartel! Veja a explicação acima.",
                    suppliesRemainingComputedTip: "Suprimentos - Suprimentos Usados, é o excedente ou déficit de suprimentos que um jogador terá a cada dia",
                    manaTip: "A quantidade de mana produzida em 24 horas (não inclui Abadia Dracônica)",
            },
            popCultureTable: {
                heading: "Detalhes da população / cultura",
                    description: "A tabela abaixo mostra a população / cultura de cada membro. Passe o mouse sobre os cabeçalhos da coluna para mais informações.",

                    // Icon Sub-Headings
                    minBoostPercent: "% Mín.Impulso",
                    levels: "Nível",
                    total: "Total",
                    working: "Trabalhando",
                    available: "Disponível",
                    required: "Necessário",

                    // Low Priority - Tool Tips
                    wonderLevelsTip: "O número total de níveis de maravilhas antigas que um jogador tem.",
                    cultureBoostPercentTip: "A porcentagem de aumento de cultura. IMPORTANTE: isso é calculado supondo NÃO AJUDA DE VIZINHOS nas culturas. Na realidade, isso provavelmente será maior em suas cidades.",
                    totalPopulationTip: "População total por residências, edifícios híbridos cultura / população e maravilhas antigas",
                    workingPopulationTip: "População Trabalhando - A quantidade consumida pelos edifícios",
                    availablePopulationTip: "População disponível",
                    totalCultureTip: "Cultura total produzida por estruturas de cultura, cultura / população edifícios híbridos e maravilhas antigas",
                    requiredCultureTip: "Cultura necessária para todos os seus edifícios",
                    availableCultureTip: "Cultura Disponível",
            },
            cityCoverageTable: {
                heading: "Cobertura da cidade",
                    description: "Mostra quantos espaços 1x1 são usados ​​na cidade de cada membro para o tipo de edifício específico. Os blocos vazios são blocos que atualmente não estão sendo usados.",
                    tiles: 'Espaços'
            },

            // HIGH PRIORITY TO TRANSLATE
            weeklyReport: {
                heading: "Relatório por e-mail semanal",
                    description: "Nós geramos automaticamente relatórios semanais adequados para compartilhar com seus membros da irmandade. Um novo relatório semanal estará disponível todos os domingos (aproximadamente por volta das 20:00 UTC) da semana anterior. Simplesmente copie a sinopse abaixo e cole!",
                    selectReportHint: "Selecione o relatório da semana final em",
                    reportsAreOptimizedFor: "Os relatórios de e-mail são otimizados para exibição no sistema de mensagens Elvenar, de modo que as colunas sejam alinhadas da maneira mais adequada possível e os nomes de usuários sejam truncados para que caibam em uma única mensagem.",
                    accolades: "Reconhecimento",
                    tourneyChamp: " - Campeão Torneio (essa semana): {0}",
                    tourneyHero: " - Herói dos Torneios (Últimas 4 semanas): {0}",
                    highestGrowthPlusPercentage: " - Maior Crescimento (pontos & percentual): {0}",
                    highestGrowthPoints: " - Maior Crescimento (pontos): {0}",
                    highestGrowthPercentage: " - Maior Crescimento (percentual): {0}",
                    highestGrowthError: " - Maior Crescimento: não pode ser determinado ainda, precisa de mais dados ",
                    newPersonalRecords: " Novos registros pessoais ",
                    userSetANewPersonalRecordFor: " * {0} estabeleceu um novo recorde pessoal para: {1}",
                    allMembersByPointGainThisWeek: "TODOS MEMBROS Pontos Ganhos / Percentual (essa semana)",
                    tournamentPointsHeader: "TORNEIO Pontos (essa semana / TOTAL DESDE {0})",
                    top8ByPercentage: " 8 Melhores por Percentual (essa semana)",
                    top8ByPointsSince: "8 Melhores por Pontos (Desde {0})",
                    top8ByPercentageSince: "8 Melhores por Percentual (Desde {0})",
                    reportGeneratedBy: "Relatório gerado por elvenstats.com, para mais informações: ",
                    mostPointsInAWeek: "Maiores pontos em uma semana",
                    highestTournamentScore: "Maior Pontuação do Torneio",
                    highestTournamentRank: "Maior classificação de torneio",
                    insufficientHistoryForThesePlayers: "* Omitido: {0} devido a histórico insuficiente. Eles serão incluídos na próxima semana",
                    insufficientHistory1Week: "* Histórico insuficiente para esta seção. Volte na próxima semana!",
                    insufficientHistory4Weeks: "* Histórico insuficiente para esta seção. São necessárias 4 semanas de dados. Verifique em breve!",
            },
            memberHistory: {
                heading: "Histórico do membro",
                    noChangesDetected: "Nenhuma mudança de membro foi detectada desde o início do acompanhamento da irmandade {0}"
            },
            // Medium Priority
            notifications: {
                unsavedChanges: 'Você tem alterações não salvas. Quando terminar de editar sua irmandade, clique no botão salvar.',
                    standbyImporting: 'Espera: Estamos importando alguns dos seus companheiros que estão faltando informações',
                    limitedHistory: "Recentemente, começamos a rastrear este {0}, então há um histórico limitado. Todos os domingos, os dados semanais aparecerão aqui, então não deixe de conferir em breve!",
                    noChangesSinceTrackingBegan: "Nenhuma alteração desde o início do acompanhamento",
            }
        },
        player: {
            fellowshipHistory: {
                heading: "Histórico da Irmandade"
            }
        },
        status: {
            realTimeUpdatesNotAvailableHeadline: "Atualizações em tempo real estão indisponíveis neste momento.",
                realTimeUpdatesNotAvailableDescription: "Isso normalmente ocorre depois que os Servidores de Jogo Elvenar são reiniciados para implantar uma atualização ou para manutenção. Quando isso ocorrer, o ElvenStats deve fazer login manualmente em todos os servidores do jogo antes que as informações possam ser recuperadas. Por favor, tente novamente a sua consulta em algumas horas. Entretanto, o site está totalmente funcional.",
                copyToClipboardSuccessful: "Copiado para a área de transferência com sucesso!",
                copyToClipboardFailed: "Falha ao copiar, selecione toda a área de texto e em seguida, use CTRL + C",
                errorOccurredImporting: "Ocorreu um erro. Ao importar dados dos Usuários.",
                errorOccurredImportingMessage: "Ocorreu um erro ao tentar importar os dados dos usuários. Por favor, tente novamente. Se o erro persistir, por favor entre em contato.",
                errorOccurredImportingWillNotBeAvailableInReports: "Usuários que não foram importados não serão incluídos nos relatórios.",
                finishedSyncSuccessful: "Concluída, a sincronização foi bem-sucedida!",
                playerIsAnonymous: "O jogador solicitou que suas informações não fossem exibidas em elvenstats.com",
                inactiveWarningTip: "Este jogador pode estar inativo. Pontuação da última alteração: {0}",
                isFriendTip: "Este jogador é amigo de ElvenStats. Eles contribuíram com seu tempo ou dinheiro para apoiar o site!",
        }
    }
}




// WEBPACK FOOTER //
// ./src/lang/br.js